// AI Generated Test
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BrokenLinksUtil } from '@client/app/pages/qa/broken-links/broken-links.util';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { QABrokenLinkService } from '@client/app/blocks/service/qa/broken-link.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@client/ng2/core/constants/mon-events.constant';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'broken-links-index',
    standalone: false,
    template: `
        @let linksTotal = links.total | monNumber;
        <page-header
            [icon]="['QA', 'BROKEN_LINKS'] | monIcons"
            [header]="'Broken Links' | translate"
            [subHeader]="'<strong>' + linksTotal + '</strong> ' + ('link' | translateWithPlural: links.total:'links')"
        >
        </page-header>
        <mon-tabs
            [showSearch]="true"
            [options]="tabs"
            [(status)]="activeTab"
            (onStatus)="onStatus($event)"
            (onSearch)="onSearch($event)"
            [search]="search"
            [minSearchLength]="1"
            [showFiltersBtn]="true"
            [(isFiltersOpen)]="isFiltersOpen"
        >
            <csv-export-button [exports]="exports"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-48 col-lg-48 col-48">
                        <table-container-top>
                            <div *ngIf="isFiltersOpen">
                                <table-filters
                                    [(open)]="isFiltersOpen"
                                    [(ngModel)]="filters"
                                    name="filters"
                                    [filters]="availableFilters"
                                    (onChanges)="updateFilters($event);getPage()"
                                >
                                </table-filters>
                            </div>
                        </table-container-top>
                        <broken-table [selected]="selected"
                                      (getPage)="getPage()"
                                      [items]="links"
                                      (onPageChange)="onPageChange($event)"
                                      (onPerPageChange)="onPageSizeChange($event)"
                                      (onSortPage)="onSortPage($event['direction'], $event['by'])"
                                      [currentSort]="currentSort"
                                      [type]="activeTab"
                                      [progress]="promise"
                                      [labels]="labels"
                                      [selectedLabels]="selectedLabels"
                                      (getLabels)="getLabels()">
                        </broken-table>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class BrokenLinksIndexComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    @Input() type: string = 'not_image';
    @Input() filter: string = '';

    selected: any[] = [];
    links: any = [];
    tabs: any[] = [];
    override isFiltersOpen: boolean = false;
    override filters: any = { labels: [], type: [], 'response code': [], 'internal or external': [] };
    override availableFilters: any = {
        labels: [],
        type: [],
        'response code': [],
        'internal or external': [],
    };
    exports: any[] = [];
    override labels: any[] = [];
    override selectedLabels: any[] = [];
    promise: any;
    qaBrokenLinksUpdateListener: any;

    override getPage = () => {
        this.selected = [];
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search,
            status: this.activeTab,
            type: this.type,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            page_fixed: false,
        };
        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }
        if (this.filters.type.length) {
            params.page_type = this.filters.type[0].id;
        }
        if (this.filters['response code'].length) {
            params.status_code = this.filters['response code'][0].id;
        }
        if (this.filters['internal or external'].length) {
            params.relation = this.filters['internal or external'][0].id;
        }

        this.promise = this.linksRepoService.getAll(params).then((data: any) => {
            this.links = data;
        }, () => {});
    };

    constructor (
        private linksRepoService: LinksRepoService,
        private translateService: TranslateService,
        private qaBrokenLinkService: QABrokenLinkService,
        public override monEventsService: MonEventService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.selected = [];
        this.search = '';
        this.type = this.type || 'not_image';
        this.links = [];
        this.tabs = [
            { name: this.translateService.getString('All broken links'), faIcon: 'fas fa-unlink', value: 'dead' },
            { name: this.translateService.getString('Ignored'), faIcon: 'fas fa-eye-slash', value: 'ignored' },
            { name: this.translateService.getString('Marked as fixed'), faIcon: 'fas fa-check-circle', value: 'fixed' },
        ];
        this.activeTab = 'dead';
        this.isFiltersOpen = false;
        this.filters = { labels: [], type: [], 'response code': [], 'internal or external': [] };
        this.availableFilters = {
            labels: [],
            type: [
                { id: 'html', name: this.translateService.getString('Pages') },
                { id: 'document', name: this.translateService.getString('Documents') },
            ],
            'response code': this.qaBrokenLinkService.getResponseCodes(),
            'internal or external': [
                { id: 'internal', name: this.translateService.getString('Internal') },
                { id: 'external', name: this.translateService.getString('External') },
            ],
        };
        this.currentSort = { by: 'dead_on_pages_count', direction: 'desc' };
        this.exports = [
            {
                name: this.translateService.getString('Broken links with page count'),
                data: {
                    category: 'dead_links',
                },
            },
            {
                tooltip: this.translateService.getString(
                    'Export list of broken links organized by page and document title',
                ),
                name: this.translateService.getString('Broken links per page'),
                data: {
                    category: 'dead_page_links',
                },
            },
        ];

        this.qaBrokenLinksUpdateListener = this.monEventsService.addListener(MON_EVENTS.RELOAD_QA_BROKEN_LINKS, () => {
            this.getPage();
        });

        this.getLabels();
        this.getPage();
    }

    override updateFilters (changes: any): void {
        if (!changes) {
            return;
        }

        this.selectedLabels = [];
        if (changes.labels.length > 0) {
            for (const label of changes.labels) {
                this.selectedLabels.push(label.id);
            }
        }

        this.filters = BrokenLinksUtil.updateLinksFilters(this.filters, changes);
        this.getPage();
    }

    ngOnDestroy (): void {
        this.monEventsService.remove(this.qaBrokenLinksUpdateListener);
    }
}
